import cn from "../../lib/classnames";
import GreenCheck from "../icons/GreenCheck";
import React from "react";
import RedX from "../icons/RedX";
import styles from "./NonInteractiveLinedInput.module.css";
import textStyles from "../../styles/Text.module.css";

type Props = {
    className?: string;
    value: string;
    valueLine2?: string;
    label: string;
    validationMessage?: string[];
    isValid: boolean;
};

export default function NonInteractiveLinedInput(props: Props) {
    return (
        <div className={cn(styles.container, props.className)}>
            <div
                className={cn(
                    textStyles.input,
                    styles.input,
                    props.validationMessage ? styles.invalidInput : undefined,
                    props.value ? styles.filledInput : styles.emptyInput,
                    props.isValid ? styles.validInput : undefined,
                    props.valueLine2 ? styles.inputValue1 : undefined,
                    "non-interactive-input", // NOTE: Using global class for focus style
                )}
            >
                {props.value}
            </div>
            <div
                className={cn(
                    styles.label,
                    props.valueLine2 ? styles.labelWithTwoLines : undefined,
                )}
                data-content={props.label}
            >
                <span className={styles.hidden}>{props.label}</span>
            </div>
            {props.valueLine2 ? (
                <div
                    className={cn(
                        textStyles.input,
                        styles.input,
                        styles.inputValue2,
                        props.validationMessage ? styles.invalidInput : undefined,
                        props.value ? styles.filledInput : styles.emptyInput,
                        props.isValid ? styles.validInput : undefined,
                    )}
                >
                    {props.valueLine2}
                </div>
            ) : null}
            <RedX
                className={cn(
                    styles.validityIcon,
                    props.validationMessage || !props.isValid
                        ? styles.showInvalid
                        : styles.hideInvalid,
                )}
            />
            <GreenCheck
                className={cn(
                    styles.validityIcon,
                    props.validationMessage || !props.isValid ? undefined : styles.showValid,
                )}
            />
            {props.validationMessage ? (
                <div className={cn(textStyles.inputError, styles.validation)}>
                    {props.validationMessage}
                </div>
            ) : null}
        </div>
    );
}
